module.exports = __webpack_public_path__ + "media/customizations/tributary/logo-new-442a4158db53465595f6d72b8ef72b5e.png";